import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import OrderOnItsWay from '@assets/order_on_its_way.svg';
import styles from './CourierListEmptyPlaceholder.module.scss';
import PIEButton from '@src/shared/components/PIEButton';
import { IconPlus } from '@justeattakeaway/pie-icons-react';
import PIEText from '@src/shared/components/PIEText';
import useOCFStatus from '@src/shared/hooks/use-ocf-status';
import QRCodeOptionsSelector from '@src/shared/components/QRCodeOptionsSelector';

interface ICourierListEmptyPlaceholderProps {
  onAction: () => void;
  onShowQRCode: () => void;
  onDownloadQRCode: () => void;
}

export const CourierListEmptyPlaceholder: FC<ICourierListEmptyPlaceholderProps> = ({
  onAction,
  onShowQRCode,
  onDownloadQRCode,
}) => {
  const { t } = useTranslation();
  const { isOCFEnabled } = useOCFStatus();
  return (
    <div className={styles.courierListEmptyPlaceholderContent}>
      <img src={OrderOnItsWay} className={styles.presentationImg} />
      <div className={styles.contentTitle}>
        <PIEText
          text={t('manage_couriers.EMPTY_LIST_PLACEHOLDER_TITLE')}
          size={'var(--xds-font-size-24)'}
          fontWeight="var(--xds-font-heading-xxl-weight)"
          align="center"
        />
      </div>
      <div className={styles.contentDescription}>
        <PIEText
          text={t('manage_couriers.EMPTY_LIST_PLACEHOLDER_DESCRIPTION')}
          size="var(--xds-font-size-16)"
          align="center"
        />
      </div>
      <div data-qa="courier-page-add-courier-button">
        {isOCFEnabled ? (
          <QRCodeOptionsSelector
            onShowQRCode={onShowQRCode}
            onDownloadQRCode={onDownloadQRCode}
            qaSelector="courier-page-add-courier-button"
            renderToggle={({ onClick }) => (
              <PIEButton
                onClick={onClick}
                icon={<IconPlus size="s" />}
                size="large"
                mode="primary"
                text={t('manage_couriers.ADD_COURIER_BUTTON_ALTERNATE')}
                type="submit"
                qaSelector="courier-page-add-courier-button"
              />
            )}
          />
        ) : (
          <PIEButton
            onClick={() => onAction()}
            icon={<IconPlus size="s" />}
            size="large"
            mode="primary"
            text={t('manage_couriers.ADD_COURIER_BUTTON')}
            type="submit"
            qaSelector="courier-page-add-courier-button"
          />
        )}
      </div>
    </div>
  );
};
